import { doc, updateDoc } from 'firebase/firestore'
import { useContext, useEffect, useState } from 'react'
import { db } from '../../firebase/firebase'
import ScoreContext from '../../store/score-context'
import FinishMessage from '../finish-message/finish-message'
import ScoreResult from './score-result'
import classes from './score.module.css'
const Score = (props) => {
    const scoreCtx = useContext(ScoreContext);
    let compliance = scoreCtx.complianceRightAnswers;
    let memes = scoreCtx.memesRightAnswers;
    const { questions } = props
    console.log(questions);
    const [winner, setWinner] = useState('')
    const [showFinishMessage, setShowFinishMessage] = useState(false)
    async function insertWinnerToFirebase(value) {
        const ref = doc(db, "MCQ-friends", scoreCtx.randomId.toString());
        
        await updateDoc(ref, {
            character: value,
            endTime: Date.now().toString(),
            memesScore:scoreCtx.memesRightAnswers,
            complianceScore:scoreCtx.complianceRightAnswers
        });

    }
    useEffect(() => {
        if (memes > compliance) {
            setWinner('chandler')
            insertWinnerToFirebase('chandler')
        }
        else if (compliance > memes) {
            setWinner('ross')
            insertWinnerToFirebase('ross')
        }
        else if (compliance === memes && (compliance > 0 || memes > 0) && (questions > (memes + compliance))) {
            setWinner('rachel')
            insertWinnerToFirebase('rachel')
        }
        else if (compliance === memes && (memes + compliance == questions)) {
            setWinner('monica')
            insertWinnerToFirebase('monica')
        }
        else if (compliance == 0 && memes == 0) {
            setWinner('joey')
            insertWinnerToFirebase('joey')
        }
    }, [memes, compliance])

    return (
        <div className={classes.scoreContainer}>
            {!showFinishMessage && <ScoreResult displayFinishMessage={() => setShowFinishMessage(true)} winner={winner} />}
            {showFinishMessage && <FinishMessage />}
        </div >
    )
}
export default Score;